<template>
  <div id="app">
    <header class="header">
      <div class="container nav">
        <router-link to="/" class="brand">
         <img  src="@/static/images/logo-011.png" style="width: 120px;" />
        </router-link>
        <button class="menu-btn" @click="mobileOpen = !mobileOpen">☰</button>
        <nav :class="{open: mobileOpen}">
          <router-link to="/" exact @click.native="mobileOpen=false">首页</router-link>
          <router-link to="/business" @click.native="mobileOpen=false">业务覆盖</router-link>
          <router-link to="/technology" @click.native="mobileOpen=false">核心技术</router-link>
          <router-link to="/cases" @click.native="mobileOpen=false">项目案例</router-link>
          <router-link to="/contact" class="nav-cta" @click.native="mobileOpen=false">联系我们 ↗</router-link>
        </nav>
      </div>
    </header>
    <main><router-view/></main>
    <footer class="footer">
      <div class="container footer-grid">
        <div><div class="footer-brand">
		<img  src="@/static/images/redbag2.png" style="width: 60px;" />
		</div><p>把智慧与哲学融入开发<br>让产品永远大于需求</p></div>
        <div><h4>快速导航</h4><router-link to="/business">业务覆盖</router-link><router-link to="/technology">核心技术</router-link><router-link to="/cases">项目案例</router-link></div>
        <div><h4>联系咨询</h4><p>段经理：15203322987</p><p>邬经理：15230480334</p></div>
      </div>
      <div class="copyright">© {{year}} 保定衡尊网络科技有限责任公司 · 版权所有</div>
    </footer>
  </div>
</template>
<script>
export default { data: () => ({ mobileOpen: false }), computed: { year () { return new Date().getFullYear() } } }
</script>